module.exports = __webpack_public_path__ + "img/card4.8795db2c.png";